import { DeliveryChartDatum } from '@/domain/models/Chart';

import { ChartDatum } from './ChartDatum';

export interface PieDatum {
  id: string | number;
  value: number;
}

export const createPieDatumFromChartDatum = (
  datum: ChartDatum | DeliveryChartDatum
): PieDatum[] => {
  return datum.data.reduce((result: PieDatum[], d) => {
    if (d.x instanceof Date) return result;
    if (d.y instanceof Date || typeof d.y === 'string') return result;

    return [
      ...result,
      {
        id: d.x,
        value: d.y,
      },
    ];
  }, []);
};
